import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router';
import { withOidcSecure } from '@axa-fr/react-oidc';
import { useDispatch, useSelector } from 'react-redux'
import { appTheme } from '../../../../../helpers/utils/Utils';



const InsufficientBalanceModel = ({ onCanelTranfer, modalClose ,onBack}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const appThemeData = appTheme(kudzuPlusTrue);
    const goalCardType = useSelector(state => state.goalCardType);

   const backToEditGoals = () => {
        dispatch({
            type: "SHOW_BALANCE_ALERT",
            payload: { showBalanceAlert: false }
        })
    };

    const handleNavigate = () => {
        if(goalCardType === 'Spending') {
            navigate("/AccountServices/Spending/TransferMoney");
        } else if (goalCardType === 'Savings'){
            navigate("/AccountServices/Savings/TransferMoney")
        }else {
            dispatch({
                type: "SHOW_BALANCE_ALERT",
                payload: { showBalanceAlert: false }
            })
            navigate('/Toolkit/SavingGoals/ManageSavingGoal/ManageSavingGoalDetails');
        }
    }

    return (
        <div className='flex flex-col justify-center items-center w-full'>
            <p className='font-hanken-grotesk lg:text-[19px] md:text-[17px] sm:text-[14px] text-[16px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] 
             md:leading-[28px] text-[var(--heading-in-modal-is-clr)] '>{t("Tap_to_add_money")}</p>
            <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' />

            <div className='flex flex-col justify-center items-center w-full'>

            <div className=' flex flex-col gap-4 justify-center items-center w-full'>
                <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={() => handleNavigate()} onKeyDown={(e) => { if (e.key === "Enter") navigate("/home/") }}>{t("addMoneyTittle")}</button>
                <button className='focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#262B3A] text-[#FEFAEE] cursor-pointer border-2 px-2 py-4 border-[#4B70B9] w-full' onClick={()=>{backToEditGoals()}}>{t("edit_saving_goals")}</button>
            </div>
            </div>

        </div>
    )
}

export default withOidcSecure(InsufficientBalanceModel)